import { enc } from './core.js';
export function domainsApi(c) {
    const base = (localId) => `/locals/${enc(localId)}/domains`;
    return {
        list: (localId) => c.get(base(localId)),
        add: (localId, body) => c.post(base(localId), body),
        verify: (localId, domainId) => c.post(`${base(localId)}/${enc(domainId)}/verify`),
        remove: (localId, domainId) => c.delete(`${base(localId)}/${enc(domainId)}`),
    };
}
//# sourceMappingURL=domains.js.map